import * as React from 'react';
import Text, { Props as TextProps } from '../Text/Text';

export interface Props extends TextProps {}

/**
 * Modal specific styled text to appear as a title.
 */
const ModalTitle: React.FunctionComponent<Props> = (props: Props) => {
  return (
    <Text { ...props }
        letterSpacing="x1"
        margin="x4"
        size="x5"
        textColor="grape-5"
        weight="bold" />
  );
};

export default ModalTitle;
